// src/pages/traduccion_especializada.js

import React from "react";
import Header from '../../components/Header'
import Footer from '../../components/Footer'

function TraduccionEspecializada() {
    return (
        <>
            <Header />
            {/* CABECERA */}
            <section className="p__cabecera" id="inicio">
                <div className="wrap text-center">
                    <h1>Traducción Certificada</h1>
                    <p>
                        Expertos en cada área que garantizan la precisión
                        terminológica.
                    </p>
                </div>
            </section>

            {/* SERVICIO */}
            <section className="empresa" id="empresa">
                <div className="wrap servicios">

                    {/* ESCRITORIO */}
                    <div className="emp3" style={{ padding: "50px" }}>
                        <ul className="mt-3">
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-circle-check"></i>
                                <span> Se realiza por un traductor colegiado y habilitado por el Colegio de Traductores del Perú (CTP)</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-circle-check"></i>
                                <span> Tiene validez legal dentro de Perú y en el exterior. Cuenta con firma y sello del traductor colegiado</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-circle-check"></i>
                                <span> Forma de entrega: En físico y/o digital</span>
                            </li>
                        </ul>


                    </div>
                    <div className="emp4" style={{ padding: "50px" }}>
                        <h3 className="text-left eyebrow font-bold" style={{ fontSize: "24px" }}>Documentos:</h3>
                        <ul className="mt-3">
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Partidas de Nacimiento</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Actas de matrimonio</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Certificados policiales</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Judiciales y penales</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Constancias de estudio</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Contratos</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Partidas registrales</span>
                            </li>
                            <li style={{ marginBottom: "15px", listStyle: "none" }}>
                                <i className="fas fa-asterisk"></i>
                                <span> Extractos bancarios</span>
                            </li>

                        </ul>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default TraduccionEspecializada;